import React from "react";

import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import { Link } from "react-router-dom";

import ApexRadial from "./ApexRadial";

const MonthlyEarning = ({ totalAssignments }) => {
  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <CardTitle className="mb-4">Total Assignments submitted</CardTitle>
          <Row>
            <Col sm={6}>
              <p className="text-muted">This month</p>
              <h3>{totalAssignments}</h3>
              <p className="text-muted">
                <span className="text-success me-2">
                  3% <i className="mdi mdi-arrow-up"></i>
                </span>
                From previous period
              </p>
              <div className="mt-4">
                <Link
                  to="/assignments"
                  className="btn btn-primary waves-effect waves-light btn-sm"
                >
                  View More <i className="mdi mdi-arrow-right ms-1"></i>
                </Link>
              </div>
            </Col>
            <Col sm={6}>
              <div className="mt-4 mt-sm-0">
                <ApexRadial dataColors='["--bs-primary"]' />
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default MonthlyEarning;
